import Svg from '@svg/index';
import { InputProps } from 'antd/lib/input';
import React from 'react';
import { useModal } from '@ui-library/modal/ModalProvider';
import { useMappingState } from '../../tableMappingProvider';
import { EditColumnWrapper, ButtonWrapper } from '../style';
import EditColumnModal from './edittColumModal';

interface EditColumnProps extends InputProps {
  defaultValue: string;
  viewOnly?: boolean;
}

const EditColumn = ({ defaultValue, viewOnly }: EditColumnProps) => {
  const mappingState = useMappingState();
  const modal = useModal();

  const nameOfMappedRows = (val: string, i: number, totalLength: number) => {
    if (i > 5) {
      return null;
    }
    return (
      <p
        style={{
          display: 'inline-block',
          margin: '3px',
          backgroundColor: defaultValue.toLowerCase() === val.toLowerCase() ? undefined : '#f5f2f2',
        }}
      >
        {i === 5 ? ` +${totalLength - 5} more` : val}
      </p>
    );
  };
  const defaultRenamedRows = mappingState.renamedRows[defaultValue] || [];
  return (
    <EditColumnWrapper editMode={!viewOnly}>
      <div
        style={{
          overflowX: 'auto',
          display: 'flex',
          maxWidth: 270,
          flexWrap: 'wrap',
          marginRight: 4,
        }}
      >
        {defaultRenamedRows.map((value, i) =>
          nameOfMappedRows(value, i, defaultRenamedRows.length),
        )}
      </div>

      <ButtonWrapper>
        <Svg
          className="editIcon"
          name="edit"
          size={12}
          onClick={() =>
            modal.show({
              footer: null,
              title: `COLUMN : ${defaultValue}`,
              okText: 'Confirm',
              content: (
                <EditColumnModal
                  viewOnly={!!viewOnly}
                  defaultValue={defaultValue}
                  mappingState={mappingState}
                />
              ),
            })
          }
        />
      </ButtonWrapper>
    </EditColumnWrapper>
  );
};

export default EditColumn;
